/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBPROFESSION, GETTOTALTYPE } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBPROFESSION:
      return Object.assign({}, state, { professionList: action.payload })
    case GETTOTALTYPE:
      return Object.assign({}, state, { totalType: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubProfession/reduce.js